import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { SEARCH_AI_INTEGRATIONS } from "./gql";

const useSearchAiIntegrations = () => {
  const { data, error, networkStatus, previousData, refetch } = useQuery(SEARCH_AI_INTEGRATIONS);

  const integrations = useMemo(() => {
    return data?.aiIntegrations || previousData?.aiIntegrations || [];
  }, [data, previousData]);

  const initialLoading = integrations.length === 0 && networkStatus === NetworkStatus.loading;

  return {
    integrations,
    error,
    initialLoading,
    refetch,
  };
};

export default useSearchAiIntegrations;
